import { DOCUMENT, NgClass } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';

import { Box, Equipment, Faim, FaimPremium, FaimUnlimited, Plan, Product, ProductFactory } from '@bytel/bytel-sales';

import { ConfigurationService } from '@services/configuration.service';
import { MainCartService } from '@services/main-cart.service';

// @dynamic
@Component({
    selector: 'checkout-empty-cart-item',
    templateUrl: './empty-cart-item.component.html',
    styleUrl: 'empty-cart-item.component.scss',
    standalone: true,
    imports: [NgClass],
})
export class EmptyCartItemComponent implements OnInit {
    @Input() public itemColor: string;
    @Input() public itemIcon: string;
    @Input() public itemLabel: string;
    @Input() public wallType: string;
    @Input() public isCartEmpty: boolean;
    @Input() public ctaAriaLabel: string;

    public textColor: string;
    public wallUrl: string;

    private _principalSubscription: Product;
    private _principalEquipment: Product;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private cartService: MainCartService,
        private configurationService: ConfigurationService,
    ) {}

    public getEquipmentWallUrl(): string {
        let wallUrl: string = this.configurationService.getData()?.global.wall.phone_simple;

        if (
            ProductFactory.Is(this._principalSubscription, Faim) ||
            ProductFactory.Is(this._principalSubscription, FaimPremium)
        ) {
            wallUrl = this.configurationService.getData()?.global.wall.box;
        }

        return wallUrl;
    }

    public getSubscriptionWallUrl(): string {
        let wallUrl: string = this.configurationService.getData()?.global.wall.main_plan;

        if (ProductFactory.Is(this._principalEquipment, Box)) {
            wallUrl = this.configurationService.getData()?.global.wall.faim;
        }

        return wallUrl;
    }

    public ngOnInit(): void {
        this.textColor = `has-text-${this.itemColor}`;
        this._principalSubscription = this.cartService.getQuote().getPrincipalProduct<Plan>('Plan');
        this._principalEquipment = this.cartService.getQuote().getPrincipalProduct<Equipment>('Equipment');
        if (
            ProductFactory.Is(this._principalSubscription, Faim) ||
            ProductFactory.Is(this._principalSubscription, FaimPremium)
        ) {
            this.itemLabel = 'Ajouter un Hotspot';
        }
        if (ProductFactory.Is(this._principalSubscription, FaimUnlimited)) {
            this.itemLabel = "Besoin d'une box&nbsp;?";
        }
        this._setUrl();
    }

    protected _setUrl(): void {
        let wallUrl: string;
        switch (this.wallType) {
            case 'equipment':
                wallUrl = this.getEquipmentWallUrl();
                break;
            case 'subscription':
                wallUrl = this.getSubscriptionWallUrl();
                break;
            case 'accessories':
                wallUrl = this.configurationService.getData()?.global.wall.accessories;
                break;
            default:
                wallUrl = this.configurationService.getData()?.global.wall[this.wallType];
                break;
        }
        this.wallUrl = wallUrl;
    }
}
